import Data from "../types/Data";

export default function hasUserGroups(data: Data) {
  return data.groupIds.length > 0;
}
